import { useMutation, useQueryClient } from "@tanstack/react-query"
import Swal from "sweetalert2"
import { saveSupplierChanges, updateReadyForReview } from "../services/myProfile.service"

export const useMyProfileMutations = ({ userLogged }) => {
	const queryClient = useQueryClient()
	const dataID = userLogged?.dataID
	const queryKey = ['supplier-myProfile', dataID]

	const saveChangesMutation = useMutation({
		mutationFn: ({ supplier }) => saveSupplierChanges({ supplier, dataID }),
		onMutate: () => {
			Swal.fire({
				toast: true,
				footer: 'Loading, please wait',
				showConfirmButton: false,
				position: "bottom-end",
				didOpen: () => {
					Swal.showLoading()
				},
			})
		},
		onSuccess: (data) => {
			Swal.fire({
				toast: true,
				icon: !data?.saveWithFile || (data?.saveWithFile && data?.fileSaved) ? 'success' : 'error',
				text: !data?.saveWithFile || (data?.saveWithFile && data?.fileSaved) ? 'Information saved successfully' : 'Failed to save information',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
				position: "bottom-end",
			})
			queryClient.invalidateQueries({ queryKey })
		},
		onError: () => {
			Swal.fire({
				toast: true,
				icon: 'error',
				text: 'Failed to save information',
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
				position: "bottom-end",
			})
		},
	})

	const readyForReviewMutation = useMutation({
		mutationFn: ({ clientID }) => updateReadyForReview({ id: dataID, clientID, username: userLogged?.username, dataID: userLogged?.dataID, rol: userLogged?.rol }),
		onMutate: () => {
			Swal.fire({
				footer: 'Loading, please wait',
				showConfirmButton: false,
				allowOutsideClick: false,
				allowEscapeKey: false,
				didOpen: () => {
					Swal.showLoading()
				},
			})
		},
		onSuccess: () => {
			Swal.fire({
				icon: 'success',
				text: 'Supplier ready for review successfully',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
			queryClient.invalidateQueries({ queryKey })
		},
		onError: (err) => {
			Swal.fire({
				icon: 'error',
				text: 'Failed to ready for review the supplier',
				showConfirmButton: false,
				timer: 5000,
				timerProgressBar: true,
			})
			console.log("Error al autorizar el supplier: " + err)
		},
	})

	const handleSaveChanges = (supplier) => {
		return saveChangesMutation.mutateAsync({ supplier })
	}

	const handleReadyForReview = (clientID) => {
		return readyForReviewMutation.mutateAsync({ clientID })
	}

	return { handleSaveChanges, handleReadyForReview }
}
